module.exports = __webpack_public_path__ + "static/img/lg-archive-thumb.7a53d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lg-archive-thumb.jpg
// module id = 02cY
// module chunks = 0